import { ChatFileMessage } from "context/adminContext";

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "heic", "heif", "webp", "gif"];

export const getFileExtension = (name = "") => {
  const dotIndex = name.lastIndexOf(".");
  return dotIndex > 0 ? name.slice(dotIndex + 1).toUpperCase() : "";
};

export const isImageFile = (file: ChatFileMessage) =>
  Boolean(file.preview) || IMAGE_EXTENSIONS.includes(getFileExtension(file.content).toLowerCase());

export const getThumbnailUrl = (file: ChatFileMessage) => file.preview ?? file.original ?? file.link;

export const getOriginalUrl = (file: ChatFileMessage) => file.original ?? file.link;

export const bytesToMegabytes = (bytes: number) => bytes / 1024 / 1024;

// Размер в МБ: не больше 3 знаков после точки, без хвостовых нулей (0.02, 1.5, 3)
export const formatMegabytes = (size: number) => String(Math.max(0.001, Math.round(size * 1000) / 1000));

// Даты сообщений приходят без зоны, хотя это UTC
export const toUtc = (date: string) => (date.at(-1) === "Z" ? date : `${date}Z`);

export const saveFile = (url: string, name: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();
};
